import { siteApiSlice } from "../../../../app/siteApiSlice";
import { UserRole } from "../../../../app/userSlice";
import { SelectListItem } from "../../../../components/input/SelectList";
import { ReviewerModel, WriterModel } from "../../shared/Models";

export interface UsageFilteredByWriterViewModel {
	courseId: number;
	writerId: number;
	writerName: string;
	writerHasImage: boolean;
	writerInitials: string;
	proctorMode: boolean;
	role: UserRole;
	summary: UsageSummary;
	constructedResponseSummary: UsageSummary;
	essays: WritingUsage[];
	constructedResponseEssays: WritingUsage[];
	peerReviewsGiven: PeerReviewGiven[];
	peerReviewsReceived: PeerReviewReceived[];
	tutorials: TutorialCategoryUsage[];
	tutorialUsageForCourse: TutorialCategoryUsage;
	licenseActive: boolean;
}

export interface UsageSummary {
	essayCount: number;
	draftCount: number;
	averageDraftPerEssayCount: number;
}

export interface WritingUsage {
	lastUsedDate: string;
	promptId: number;
	promptName: string;
	draftCount: number;
	inProgress: boolean;
	essayId: number;
}

export interface PeerReviewGiven extends WriterModel {
	reviewId: number;
	reviewDate: string;
	promptName: string;
	isAnonymous: boolean;
}

export interface PeerReviewReceived extends ReviewerModel {
	reviewId: number;
	reviewDate: string;
	promptName: string;
	isAnonymous: boolean;
}

export interface TutorialCategoryUsage {
	tutorialCategoryId: number;
	tutorialCategoryName: string;
	timeSpent: string;
	timeSpentString: string;
	timeSpentSeconds: number;
	lastUsedDate?: string;
}

export interface TutorialHistoryViewModel {
	allFoci: SelectListItem[];
	tutorialsByCategory: TutorialsByCategoryViewModel[];
}

export interface TutorialsByCategoryViewModel {
	name: string;
	categoryId: number;
	tutorials: TutorialUsage[];
}

export interface TutorialUsage {
	tutorialName: string;
	tutorialId: number;
	dateStarted: string;
	timeSpent: string;
	timeSpentSeconds: number;
	timeSpentString: string;
}

export const studentUsageReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		writerUsageReport: build.query<
			UsageFilteredByWriterViewModel,
			{ writerId?: number; courseId?: number }
		>({
			query: (arg) => {
				const { writerId, courseId } = arg;
				return {
					url: `/usage-report`,
					params: { writerId, courseId },
				};
			},
			providesTags: ["WritingHistory", "CurrentCourse"],
		}),
		getTutorialHistory: build.query<
			TutorialHistoryViewModel,
			{ writerId?: number; courseId?: number }
		>({
			query: (arg) => {
				const { writerId, courseId } = arg;
				return {
					url: `/Report/GetTutorialHistory`,
					params: { writerId, courseId },
				};
			},
			providesTags: ["LessonHistory", "CurrentCourse"],
		}),
	}),
});

export const { useWriterUsageReportQuery, useGetTutorialHistoryQuery } = studentUsageReportApiSlice;
